import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";
import axios from "axios";

const UrlContext = createContext();

export const UrlProvider = ({ children }) => {
    const [banquetUrls, setBanquetUrls] = useState([]);
    const [loading, setLoading] = useState(false);

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [token, setToken] = useState(() => localStorage.getItem("token"));

    useEffect(() => {
        const syncAuth = () => {
            setToken(localStorage.getItem("token"));
        };

        window.addEventListener("authChanged", syncAuth);
        return () => window.removeEventListener("authChanged", syncAuth);
    }, []);

    const fetchUrls = useCallback(async () => {
        if (!token) {
            setBanquetUrls([]);
            return;
        }

        try {
            setLoading(true);

            const { data } = await axios.post(
                `${baseUrl}/geturls`,
                { token }
            );

            const urlData = data?.urls || [];

            const banquetUrls = urlData.filter(
                (item) => item.type?.toLowerCase() === "banquet"
            );

            setBanquetUrls(banquetUrls);
        } catch (error) {
            console.error("Failed to fetch urls:", error);
            setBanquetUrls([]);
        } finally {
            setLoading(false);
        }
    }, [token, baseUrl]);

    useEffect(() => {
        fetchUrls();
    }, [fetchUrls]);

    return (
        <UrlContext.Provider
            value={{
                banquetUrls,
                loading,
                fetchUrls,
            }}
        >
            {children}
        </UrlContext.Provider>
    );
};

export const useUrls = () => {
    const context = useContext(UrlContext);

    if (!context) {
        throw new Error(
            "useUrls must be used within UrlProvider"
        );
    }

    return context;
};